import React, { useEffect, useMemo, useState } from "react";
import { GetRamaMessDashbordApi } from "../../../api/api";
import { useNavigate } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { TbClock } from "react-icons/tb";
import CustomTable from "../../../ui/custom-table";
import {
  MdOutlineCalendarMonth,
  MdOutlineLocationOn,
  MdWifiTethering,
} from "react-icons/md";
import { IoCameraOutline } from "react-icons/io5";
import HairCoverBarChart from "../../../Components/Graphs/HairCoverBarChart";

function RamaMessDashbord() {
  const navigate = useNavigate();
  const [eventData, setEventData] = useState([]);
  console.log("eventData", eventData);
  const today = new Date();
  const options = { day: "2-digit", month: "short", year: "numeric" };
  const formattedDate = today.toLocaleDateString("en-GB", options);

  const [eventrecord, setEventRecord] = useState([]);
  console.log("eventrecord", eventrecord);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [totalRows, setTotalRows] = useState(0);
  const [activeFilter, setActiveFilter] = useState("daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [showCustomFilter, setShowCustomFilter] = useState(false);

  const fetchEventData = async () => {
    setLoading(true);
    try {
      const data = await GetRamaMessDashbordApi(startDate, endDate);
      //console.log("data", data);
      if (data?.data?.status === true) {
        setEventData(data?.data?.data);
        setEventRecord(data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEventData();
    updateDateRange("daily");
  }, []);

  const updateDateRange = (filter) => {
    const today = new Date();
    let start, end;

    switch (filter) {
      case "daily":
        start = end = today;
        break;
      case "weekly":
        start = new Date(today);
        start.setDate(today.getDate() - 7);
        end = today;
        break;
      case "monthly":
        start = new Date(today);
        start.setMonth(today.getMonth() - 1);
        end = today;
        break;
      default:
        start = end = today;
    }

    const format = (date) => date.toISOString().split("T")[0];
    setStartDate(format(start));
    setEndDate(format(end));
  };

  const durationChartData = useMemo(() => {
    if (!eventData?.duration_buckets) return [];

    return Object.entries(eventData.duration_buckets)
      .filter(([_, value]) => value > 0)
      .map(([key, value]) => ({
        name: key
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase()),
        value,
      }));
  }, [eventData]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "employee_image",
        header: "Image",
        Cell: ({ row }) => {
          const imagePath = row.original.image_path;
          const imageUrl = imagePath
            ? `https://visionemptrack.greymatterz.com/hair_mesh/${imagePath}`
            : "";

          return (
            imageUrl && (
              <img
                src={imageUrl}
                alt="Employee"
                style={{
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            )
          );
        },
      },
      {
        accessorKey: "created_at",
        header: "Timestamp",
        Cell: ({ cell }) => {
          const raw = cell.getValue();
          if (!raw) return "-";
          const date = new Date(raw);
          return date.toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          });
        },
      },
      {
        accessorKey: "is_hair_covered",
        header: "Cap Detected",
        Cell: ({ row }) => {
          return (
            <div>
              <span>{row?.original?.is_hair_covered ? "Yes" : "No"}</span>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (startDate && endDate) {
      fetchEventData();
    }
  }, [startDate, endDate, pagination]);

  return (
    <div>
      <div>
        <div className="p-5 bg-white">
          <h3 className="mb-4">Hygiene Monitoring</h3>
          <div className="customerDwellTime">
            <div className="itemsBox">
              <span>
                <IoCameraOutline size={26} />
              </span>
              <div className="">
                <h5>Camera</h5>
                <h3>Mess</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineLocationOn size={26} />
              </span>
              <div className="">
                <h5>Location</h5>
                <h3>Rama Mess</h3>
              </div>
            </div>

            <div className="itemsBox">
              <span>
                <MdOutlineCalendarMonth size={26} />
              </span>
              <div className="">
                <h5>Tracking</h5>
                <h3>{formattedDate}</h3>
              </div>
            </div>

            <div className="itemsBox" style={{ marginLeft: "auto" }}>
              <button
                className="eventModeBtn"
                onClick={() => navigate("/mess-ditection")}
                style={{
                  backgroundColor: "red",
                  color: "white",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "8px",
                  padding: "8px 20px",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  cursor: "pointer",
                }}
              >
                <MdWifiTethering size={18} />
                Live
              </button>
            </div>
          </div>
        </div>
        <div className="p-5 border-top">
          <div className="d-flex">
            <h4 className="">Attendance Analyse</h4>
          </div>

          <div className="row">
            <div className="col-lg-6">
              <div className="customerAnalysesGrid">
                <div className="itemsBox">
                  <span>
                    <FaRegUser size={30} />
                  </span>
                  <div className="">
                    <h5>Without cap</h5>
                    <div className="customer">
                      {eventrecord?.stats?.hair_covered_false}
                      <p>Students</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>With Cap</h5>
                    <div className="customer">
                      {eventrecord?.stats?.hair_covered_true}
                      <p>Students</p>
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Area</h5>
                    <div className="customer">
                      {eventrecord?.stats?.high_risk_zone}
                      {/* <p>Students</p> */}
                    </div>
                  </div>
                </div>

                <div className="itemsBox">
                  <span>
                    <TbClock size={30} />
                  </span>
                  <div className="">
                    <h5>Total Number</h5>
                    <div className="customer">
                      {eventrecord?.stats?.total}
                      <p>Number</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="filter-toggle-wrapper d-flex justify-content-end mb-3 flex-wrap">
                <div className="filter-toggle-group">
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "daily" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("daily");
                      updateDateRange("daily");
                    }}
                  >
                    Daily
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "weekly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("weekly");
                      updateDateRange("weekly");
                    }}
                  >
                    Weekly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "monthly" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("monthly");
                      updateDateRange("monthly");
                    }}
                  >
                    Monthly
                  </button>
                  <button
                    className={`filter-toggle-btn ${
                      activeFilter === "custom" ? "active" : ""
                    }`}
                    onClick={() => {
                      setActiveFilter("custom");
                      updateDateRange("custom");
                      setShowCustomFilter(true);
                    }}
                  >
                    Custom
                  </button>
                </div>
                {activeFilter === "custom" && showCustomFilter && (
                  <div className="d-flex gap-3 align-items-center mb-3 flex-wrap custom-date-wrapper p-3 bg-light rounded">
                    <div>
                      <label className="form-label">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customStart}
                        onChange={(e) => setCustomStart(e.target.value)}
                      />
                    </div>
                    <div>
                      <label className="form-label">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={customEnd}
                        onChange={(e) => setCustomEnd(e.target.value)}
                      />
                    </div>
                    <div>
                      <button
                        className="btn btn-primary mt-4"
                        onClick={() => {
                          setStartDate(customStart);
                          setEndDate(customEnd);
                          setShowCustomFilter(false); // hide after apply
                        }}
                        disabled={!customStart || !customEnd}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                )}
              </div>

              <div className="graphBox p-4 bg-white shadow-sm rounded">
                <h5 className="mb-3">Hair Net Violation Trends</h5>
                <HairCoverBarChart stats={eventrecord?.stats} />
              </div>
            </div>
          </div>

          <div className="mt-5 cstTableCls">
            <CustomTable
              columns={columns}
              data={eventData}
              loading={loading}
              pagination={pagination}
              onPaginationChange={(updater) => {
                setPagination((prev) => {
                  const newPagination =
                    typeof updater === "function"
                      ? updater(prev)
                      : { ...prev, ...updater };
                  return newPagination;
                });
              }}
              rowCount={totalRows}
              showsearch={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RamaMessDashbord;
